import { createDetailResponseSchema, createListResponseSchema } from 'src/feature/bite/domain';
import z from 'zod';

export const ProductSchema = z.object({
  productId: z.string(),
  name: z.string(),
  description: z.string(),
  price: z.number(),
  image: z.string(),
});

export const ProductSchemaResponse = createDetailResponseSchema(ProductSchema);

export type Product = z.infer<typeof ProductSchema>;
export type ProductResponse = z.infer<typeof ProductSchemaResponse>;

export const MarketListItemSchema = z.object({
  id: z.string(),
  productName: z.string(),
  price: z.number(),
  image: z.string(),
})

export const MarketListSchemaResponse = createListResponseSchema(MarketListItemSchema.array())

export type MarketListItem = z.infer<typeof MarketListItemSchema>
export type MarketList = z.infer<typeof MarketListSchemaResponse.shape.response>;
export type MarketListResponse = z.infer<typeof MarketListSchemaResponse>

const filterListSchema = z.array(
  z.object({
    operator: z.number(),
    key: z.string(),
    value: z.array(z.string()),
    logicalOp: z.number(),
    childFilters: z.array(z.object({})),
  })
);

const orderListSchema = z.array(
  z.object({
    type: z.number(),
    key: z.string()
  })
);

const pagingSchema = z.object({
  currentPageNumber: z.number(),
  pageSize: z.number(),
});

export const listFilterSchema = z.object({
  filterList: filterListSchema,
  orderList: orderListSchema,
  paging: pagingSchema,
});

export type ListFilter = z.infer<typeof listFilterSchema>;
